import * as tslib_1 from "tslib";
import * as React from 'react';
import { IconButton, FontIcon } from 'material-ui';
import slugify from 'slugify';
import { copyTextToClipBoard } from 'src/utils/dom';
import { GIT_BRANCH_COPIED_TO_CLIPBOARD } from 'src/constants/messages';
function getBranchType(ticketType) {
    switch (ticketType) {
        case "Hibajavítás":
            return "hotfix";
        default:
            return "feature";
    }
}
function getTicketBranchName(task) {
    var slugOptions = {
        lower: true,
        remove: /[^\w\d\s]/
    };
    var branchType = getBranchType(task.ticketType);
    var branchIdentifier = slugify(task.stepName, tslib_1.__assign({}, slugOptions, { lower: false }));
    var branchTitle = slugify(task.title, slugOptions);
    return (branchType + "/" + branchIdentifier + "-" + task.headId + "-" + branchTitle).substring(0, 255);
}
var GitBranchButton = /** @class */ (function (_super) {
    tslib_1.__extends(GitBranchButton, _super);
    function GitBranchButton(props) {
        var _this = _super.call(this, props) || this;
        _this.copyBranchNameToClipBoard = function (e) {
            e.preventDefault();
            var _a = _this.props, task = _a.task, userStore = _a.userStore;
            var branchName = getTicketBranchName(task);
            copyTextToClipBoard(branchName);
            userStore.notify(GIT_BRANCH_COPIED_TO_CLIPBOARD);
        };
        return _this;
    }
    GitBranchButton.prototype.render = function () {
        return (React.createElement(IconButton, { onClick: this.copyBranchNameToClipBoard, tooltip: "Git branch n\u00E9v gener\u00E1l\u00E1sa" },
            React.createElement(FontIcon, { color: "white", className: "material-icons" }, "device_hub")));
    };
    return GitBranchButton;
}(React.Component));
export default GitBranchButton;



//////////////////
// WEBPACK FOOTER
// ./src/components/GitBranchButton.tsx
// module id = 772
// module chunks = 0